











































import _ from 'lodash';
import { Loader } from 'mycorems-app-shared';
import {
  UnsubscribeBtn,
  offSubscribedToAccount,
  offUnsubscribedFromAccount,
  onSubscribedToAccount,
  onUnsubscribedFromAccount,
} from 'mycorems-app-accounts';
import { AccountSubscriber, AccountSubscriberFilters, Client } from '@/types';
import { UserContextMixin } from '@/mixins';
import eventBus from '@/messaging/event-bus';
import { EmailReportGenerated, PricePlanStarted, ClientEdited } from '@/messaging/events';
import repository from './account-subscriber-repository';
import ClientItem from '../account/client/ClientItem.vue';
import clientRepository from '../account/client/client-repository';

interface Data {
  task: Promise<AccountSubscriber[]>|null,
  accountSubscribers: AccountSubscriber[],
  searchQuery: string|null,
  clientTask: Promise<Client>|null,
  maxItems: number,
}

export default UserContextMixin.extend({
  props: {
    searchable: {
      type: Boolean,
      default: false,
    },
  },
  data(): Data {
    return {
      task: null,
      accountSubscribers: [],
      searchQuery: null,
      clientTask: null,
      maxItems: 4,
    };
  },
  watch: {
    userId: {
      handler() {
        this.load();
      },
      immediate: true,
    },
  },
  computed: {
    viewBtnLabel(): string {
      return (this.accountSubscribers.length > this.maxItems)
        ? `Show All (${this.accountSubscribers.length - this.maxItems})` : 'Show Less';
    },
    filteredSubscribers(): AccountSubscriber[] {
      if (!this.searchable) return this.accountSubscribers;
      const subscribers = this.accountSubscribers.filter((accountSubscriber: AccountSubscriber) => {
        const label = accountSubscriber.account.name;
        if (!this.searchQuery) return true;
        return (label.toLowerCase().indexOf(this.searchQuery) >= 0);
      });
      return subscribers.slice(0, this.maxItems);
    },
    filters(): AccountSubscriberFilters {
      return {
        userId: this.userId,
      };
    },
  },
  methods: {
    viewToggle(): void {
      if (this.accountSubscribers.length > this.maxItems) {
        this.maxItems = this.accountSubscribers.length;
      } else {
        this.maxItems = 4;
      }
    },
    add(accountSubscriber: AccountSubscriber): void {
      this.accountSubscribers.unshift(accountSubscriber);
    },
    remove(accountSubscriberId): void {
      const index = this.accountSubscribers.findIndex(as => as.id === accountSubscriberId);
      if (index >= 0) {
        this.accountSubscribers.splice(index, 1);
      }
    },
    getClient(id: string): Promise<Client> {
      return clientRepository.find(id);
    },
    onSubscribe(event): void {
      const accountSubscriber = _.cloneDeep(event.accountSubscriber);
      if (accountSubscriber.user.id === this.userId) {
        this.clientTask = this.getClient(accountSubscriber.account.id);
        this.clientTask.then((client: Client) => {
          const subscriber = _.set(accountSubscriber, 'account', client);
          this.add(subscriber);
        });
      }
    },
    onUnsubscribe(event): void {
      const { accountSubscriber } = event;
      if (accountSubscriber.user.id === this.userId) {
        this.remove(accountSubscriber.id);
      }
    },
    onClientEdited(event: ClientEdited): void {
      const index = this.accountSubscribers.findIndex(acctSub => acctSub.account.id === event.id);
      if (index >= 0) {
        this.accountSubscribers[index].account.name = event.name;
      }
    },
    load() {
      this.task = repository.findAll(this.filters);
      this.task.then((accountSubscribers: AccountSubscriber[]) => {
        this.accountSubscribers = accountSubscribers;
      });
    },
  },
  created(): void {
    eventBus.$on(PricePlanStarted.eventName, this.load);
    eventBus.$on(EmailReportGenerated.eventName, this.load);
    eventBus.$on(ClientEdited.eventName, this.onClientEdited);
    onSubscribedToAccount(this.onSubscribe);
    onUnsubscribedFromAccount(this.onUnsubscribe);
  },
  beforeDestroy(): void {
    eventBus.$off(PricePlanStarted.eventName, this.load);
    eventBus.$off(EmailReportGenerated.eventName, this.load);
    eventBus.$off(ClientEdited.eventName, this.onClientEdited);
    offSubscribedToAccount(this.onSubscribe);
    offUnsubscribedFromAccount(this.onUnsubscribe);
  },
  components: {
    loader: Loader,
    'client-item': ClientItem,
    'unsubscribe-btn': UnsubscribeBtn,
  },
});
